window.addEventListener("load", () => {
  if (document.getElementById("cta_footer")) {
    if (
      !window.localStorage.getItem("lastFooterClosed") ||
      Date.now() - window.localStorage.getItem("lastFooterClosed") > 900000
    ) {
      const body = document.getElementById("body");
      const ctaFooterNotice = document.createElement("div");
      ctaFooterNotice.classList.add(
        "h-px",
        "top-[5rem]",
        "w-px",
        "absolute",
        "left-0",
        "block"
      );
      ctaFooterNotice.setAttribute("id", "ctaFooterNotice");
      body.appendChild(ctaFooterNotice);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            const ctaFooter = document.getElementById("cta_footer");
            ctaFooter.classList.remove("translate-y-96");
            ctaFooter.classList.add("translate-y-0");
            observer.unobserve(footerNotice);

            let text = document.getElementById('footerCTAText');
            let link = document.getElementById('footerCTALink');
            let covers = document.querySelectorAll('.cover');
        
            text.classList.add('footerCTA__text');
            link.classList.add('footerCTA__link');
            let count = 1;
            covers.forEach(cover => {
              cover.classList.add('footerCTA__cover');
              cover.classList.add(`footerCTA__cover--${count}`);
              count++;
            })
          }
        });
      });

      let footerNotice = document.getElementById("ctaFooterNotice");
      observer.observe(footerNotice);

      const closeButton = document.getElementById("closeCtaBtn");
      closeButton.addEventListener("click", () => {
        const ctaFooter = document.getElementById("cta_footer");
        const footer = document.querySelector("footer");
        ctaFooter.classList.remove("translate-y-0");
        ctaFooter.classList.add("translate-y-92");
        footer.classList.remove("pb-60", "sm:pb-48", "md:pb-40", "xl:pb-32");
        footer.classList.add("pb-20");
        ctaFooter.parentNode.removeChild(ctaFooter);
        let currentTime = Date.now();
        window.localStorage.setItem("lastFooterClosed", currentTime);
      });
    }
  }
});
